<template>
  <div class="charging">
    <el-row class="charging-map">
      <el-col :span="24">
        <!-- 地图 -->
        <div class="map" id='readmeMap'></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="charging-title">
          <span class="cross"></span>
          <span class="title-name bold">充电站(桩)查询</span>
          <span class="cross"></span>
        </div>
      </el-col>
    </el-row>
    <div class="charging-box w1400">
      <el-row>
        <el-col :span="6">
          <div class="search">
            <el-input placeholder="请输入内容" v-model="input3">
              <el-button slot="append" icon="el-icon-search" @click='search'></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row class="border">
        <el-col :span="8">
          <ul class="right-list" v-infinite-scroll="load">
            <li v-for="(item,i) in suggestData" @click="changeIndex(i)"
                :class="[charingIndex==i?'isActive ullist':'ullist']">
              <div class="font16 cleartext">{{ item.tg003 }}</div>
              <div class="font16 text-r">...</div>
              <div class="font16">
                <span>功率：{{ item.tg005 | formatG }}</span>
                <span class="ml64">单价：{{ item.tg006 }} - 2.80</span>
              </div>
            </li>
          </ul>
        </el-col>
        <el-col :span="16">
          <div class="charging-inf">
            <div>
              <img src="../../assets/charging.png" alt="">
            </div>
            <div class="charging-name">
              <div class="font16 mt13 pl18 cleartext">名称:{{ resource.tg003 }}</div>
              <div class="font16 mt13 pl18 cleartext">位置:{{ resource.tg004 }}</div>
              <div class="font16 mt13 pl18">功率:{{ resource.tg005 }} &nbsp;&nbsp;数量:
                {{ resource.tg014 ? resource.tg014 : 0 }}
              </div>
              <div class="font16 mt13 pl18">单价:{{ resource.tg006 }}</div>
              <div class="font16 mt13 pl18">品牌:{{ resource.tg004 }}</div>
              <div class="font16 mt13 pl18">服务联系人:{{ resource.tg009 }}</div>
              <div class="font16 mt13 pl18 cleartext">所属公司:{{ resource.tg008 }}</div>
            </div>
          </div>
          <div class="charging-text">
            <div class="bold font16">
              备注
            </div>
            <div class="moretext font16">
              {{ resource.tg013 ? resource.tg013 : '暂无更多介绍' }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <MapWay :drawer.sync='drawer' :destination='itemClick'></MapWay>
  </div>
</template>

<script>
import Gmap from "../../public/Gmap";
import MapWay from "../common/mapWay.vue"
export default {
  mixins:[Gmap],
  components:{
    MapWay,
  },
  data() {
    return {
      input3: '',
      //map
      map: '',
      markers: [],
      //数据
      resource: {
        tg001: '',
        tg002: '',
        tg003: '',
        tg004: '',
        tg005: '',
        tg006: '',
        tg007: '',
        tg008: '',
        tg009: '',
        tg010: ''
      },
      suggestData: [],
      pageSize: 20,
      currentPage: 1,
      charingIndex: 0
    }
  },

  mounted() {
    this.initMap();
    (async () => {
      let local = await this.getCarMarkerData();
      // this.suggestData = local;
      this.resource = local[0];
      local.forEach((ele, ind) => {
        try {
          ele.tg011 = ele.tg011.split(',');
        } catch (e) {
          console.error('split error');
        }
        this.initMarker(ele, ind)
      })
      //给marker添加信息窗体
      local.forEach((ele, i) => {
        this.initMapInfo(this.markers[i], ele);
      })
    })()
  },
  watch: {
    input3() {
      if (this.input3.trim().length < 1) {
        this.getCarMarkerData();
      }
    }
  },
  methods: {
    search() {
      this.$axios.post('/api/chargingPile/search', {
        skip: 0,
        pageSize: 100,
        word: this.input3
      }).then(res => {
        this.suggestData = res.data.data;
      })
    },
    //获取充电桩信息
    async getSuggest() {
      const {
        data: res
      } = await this.$axios.post('/api/chargingPile/list', {
        skip: this.pageSize * this.currentPage - this.pageSize,
        pageSize: this.pageSize,
        order: 'tg015'
      })
      if (res.code != 200) {
        return this.$message({
          type: 'error',
          message: '获取充电桩失败'
        })
      }

    },
    // //初始化标记点
    initMarker(postion, ind) {
      // 创建一个 Icon
      let icon = new AMap.Icon({
        size: new AMap.Size(24, 30),
        // 图标的取图地址
        image: require("../../assets/cdz.png"),
        // 图标所用图片大小
        imageSize: new AMap.Size(24, 30),

      });
      let markerContent = `<div style='position:relative;'>
                                  <img src='http://file.sywlfz.com/sylink/Images/rechargeStation.png' style='width:24px;height:30px;' />
                                  <span style='color:#a52a2a;position:absolute;left:10px;top:-15px;'>${ind}</span>
                            </div>`;
      //自定义marker
      let marker = new AMap.Marker({
        map: this.map,
        position: postion.tg011,
        icon: icon,
        // content:markerContent,
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-13, -30),
        // content:markerContent
      });
      this.markers.push(marker);
      //添加maerkers 到地图
      this.map.add([marker]);
    },
    //初始化窗体
    initMapInfo(marker, info) {
      //实例化信息窗体
      let infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: createInfoWindow(info),
        offset: new AMap.Pixel(16, -45)
      });
      //鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, 'mouseover', () => {
        infoWindow.open(this.map, marker.getPosition());
      });
      AMap.event.addListener(marker, 'click', (res) => {
        this.itemClick = info.tg011;
        this.drawer = true;
        // infoWindow.open(this.map, marker.getPosition());
      });
      AMap.event.addListener(marker, 'mouseout', () => {
        this.map.clearInfoWindow();
      });

      //构建自定义信息窗体
      function createInfoWindow(content) {
        let href;
        if (Array.isArray(content.tg011) && content.tg011.length == 2) {
          href = `https://gaode.com/regeo?lng=${content.tg011[0]}&lat=${content.tg011[1]}&name=&adcode=`;
        } else {
          href = "https://gaode.com/regeo?lng=110.79&lat=32.65&name=&adcode=";
        }
        let info = document.createElement("div");
        info.style.backgroundColor = "#F8F8F8";
        info.style.width = '318px';
        info.style.cursor = 'pointer';
        info.style.borderRadius = '0 0 4px 4px';
        info.style.marginBottom = '-25px';
        //init title
        info.innerHTML =
          `
                          <div class="carinfo" style="display: flex;flex-wrap: nowrap;align-items: center;padding: 10px 0 7px 8px;">
                              <div style='font-size: 14px; color: #666;height:83px display: flex;flex-direction: column;align-content: space-between;'>
                                  <div style='margin-bottom: 8px;'>名称:&nbsp;<span style="font-weight: 700">${content.tg003}</span></div>
                                  <div style='margin-bottom: 8px;'>位置:&nbsp;${content.tg004}</div>
                                  <div style='margin-bottom: 8px;'>充电桩数量:&nbsp;${content.tg014 ? content.tg014 : ''}</div>
                                  <div style='margin-bottom: 8px;'>状态:&nbsp;<span style="font-weight: 700">${content.tg012 ? '正常' : '故障'}</span></div>
                                   <a href="${href}" target="_blank">点击此处导航(或者点击小图标)</a>
                              </div>
                          </div>`;

        return info;
      }


    },

    getCarMarkerData() {
      return new Promise((resolve, reject) => {
        this.$axios.post('/api/chargingPile/list', {
          pageSize: 150,
          where: 'and tg015=1',
          order: ' tg015 ',
        }).then(res => {
          this.suggestData = res.data.data;
          resolve(res.data.data)
        }).catch(() => {
          reject();
        })
      })
    },
    changeIndex(i) {
      this.charingIndex = i;
      this.resource = this.suggestData[i];
    }
  },
  filters: {
    fromaDate(time) {
      let date = new Date();
      let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
      let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
      let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
      return hours + ':' + minutes + ':' + seconds;
    },
    formatG(value) {
      return parseInt(value).toFixed() + 'KW';
    }
  }
}
</script>
<style scoped>
.charging {
  width: 100%;
  color: #333333;
}

.map {
  width: 100%;
  height: 77.1rem;
}

.search {
  margin-bottom: 3.2rem;
}

.charging-title {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin-top: 3.2rem;
  margin-bottom: 3.5rem;
}

.title-name {
  margin: 0 2.4rem;
  font-size: 3.2rem;
}

.cross {
  display: block;
  width: 2.1rem;
  height: 0.3rem;
  border-radius: 0.2rem;
  background-color: #333333;

}

.charging-box {
  overflow: hidden;
  /*margin: 0 26rem;*/
}

.border {
  min-height: 52.3rem;
  border: 1px solid #DCDCDC;
  margin-bottom: 8.4rem;

}

.right-list {
  width: 100%;
  height: 52.3rem;
  overflow: auto;
}

.ullist {
  box-sizing: border-box;
  /*height: 9.5rem;*/
  padding: 1.6rem 3.2rem 1.6rem 1.6rem;
  margin-bottom: 0.8rem;
  background-color: #F8F8F8;
}

.ml64 {
  margin-left: 6.4rem;
}

.text-r {
  text-align: right;
}

.isActive {
  background-color: #DCDCDC;
}

.charging-inf {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  background-color: #F8F8F8;
  padding-bottom: 0.9rem;
}

.charging-inf img {
  display: block;
  width: 30.5rem;
  height: 28.3rem;
  margin-right: 0.9rem;
}

.charging-name {
  flex: 1;
  background-color: white;
  padding-top: 1.2rem;
}

.charging-text {
  padding: 1.6rem 2.4rem;
  background-color: white;
}

.mt13 {
  margin-top: 1.3rem;
}

.pl18 {
  padding-left: 1.8rem;
}

.moretext {
  margin-top: 1.2rem;
  color: #9B9B9B;
}
</style>



// WEBPACK FOOTER //
// src/components/page/charging.vue